console.log('project v2');

export const projectName = 'Project name';